import { render, staticRenderFns } from "./MarkingExamIndex.vue?vue&type=template&id=824a29d8&scoped=true"
import script from "./MarkingExamIndex.vue?vue&type=script&lang=js"
export * from "./MarkingExamIndex.vue?vue&type=script&lang=js"
import style0 from "./MarkingExamIndex.vue?vue&type=style&index=0&id=824a29d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824a29d8",
  null
  
)

export default component.exports